import type { LLImageElement } from '../../types';

export function ImageElement({ element }: { element: LLImageElement }) {
  return (
    <img
      src={element.imageUrl}
      alt=""
      className="rounded-md border max-w-full h-auto"
      loading="lazy"
    />
  );
}
